import { USER_ROLES } from './constants';

/**
 * Checks if a user has a specific granular permission
 */
export const hasPermission = (user, userRole, permissionKey) => {
    // Super admin has all permissions
    if (userRole === USER_ROLES.SUPER_ADMIN) {
        return true;
    }

    // If no user or no granularPermissions, return false
    if (!user || !user.granularPermissions) {
        return false;
    }

    // Check if permission exists in granularPermissions
    let permission = user.granularPermissions[permissionKey];
    if (!permission) {
        return false;
    }

    // Check if read permission is true (minimum requirement for visibility)
    return permission.read === true;
};

/**
 * Checks if user has any HRMS-related permissions
 */
export const hasHRMSPermission = (user, userRole) => {
    if (userRole === USER_ROLES.SUPER_ADMIN) return true;
    if (!user || !user.granularPermissions) return false;

    const hrmsPermissions = [
        'employee_management', 'recruitment', 'onboarding', 'hr_backoffice',
        'attendance', 'payroll', 'performance', 'training',
        'exit_management', 'compliance_policy', 'reports', 'system_hrms'
    ];

    return hrmsPermissions.some(permKey => {
        const permission = user.granularPermissions[permKey];
        return permission && permission.read === true;
    });
};

/**
 * Checks if user has any CRM-related permissions
 */
export const hasCRMPermission = (user, userRole) => {
    if (userRole === USER_ROLES.SUPER_ADMIN) return true;
    if (!user || !user.granularPermissions) return false;

    const crmPermissions = [
        'lead_management', 'field_sales', 'opportunity_management',
        'quotation_management', 'order_management', 'customer_management', 'customer_payment',
        'ticket_management', 'customer_support', 'support_tickets',
        'analytics', 'target_achievement', 'chatbot_management', 'system_crm'
    ];

    return crmPermissions.some(permKey => {
        const permission = user.granularPermissions[permKey];
        return permission && permission.read === true;
    });
};

/**
 * Checks if user is an employee (has self_service but no HRMS permissions)
 */
export const isEmployee = (user, userRole) => {
    if (userRole === USER_ROLES.SUPER_ADMIN) return false;
    if (userRole === USER_ROLES.EMPLOYEE) return true;

    if (!user || !user.granularPermissions) return false;

    const hasSelfService = user.granularPermissions['self_service']?.read === true;
    return hasSelfService && !hasHRMSPermission(user, userRole);
};
